var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"text-center text-white"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","width":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }